const faqItems = [
  {
    q: '每日大瓜的信息来源可靠吗？',
    a: '每一条深扒内容都经过多源交叉验证，包括公开报道、业内人士投稿、社交平台一手信息等。我们坚持「不编造、不美化」原则，对无法核实的内容明确标注「待证实」。',
  },
  {
    q: '如何向每日大瓜投稿爆料？',
    a: '你可以通过页面底部的投稿入口发送邮件，或在 #contact 模块提交爆料信息。我们承诺对投稿人信息严格保密，所有爆料经核实后才会发布。',
  },
  {
    q: '为什么有些瓜看不到后续了？',
    a: '部分事件因涉及法律诉讼、隐私保护或当事人要求，我们会暂停追踪报道。已发布的往期内容仍可在对应分类中查阅，不会被删除。',
  },
  {
    q: '可以在每日大瓜上评论互动吗？',
    a: '目前每日大瓜为单向内容平台，暂不支持用户直接评论。我们正在规划社区功能，届时瓜友们可以在遵守社区规范的前提下自由讨论。',
  },
  {
    q: '每日大瓜的文章可以转载吗？',
    a: '欢迎转载，但需注明出处为「每日大瓜」并附带原文链接。商业媒体、自媒体大号转载前请通过投稿邮箱联系我们获取授权。',
  },
  {
    q: '如何第一时间收到最新爆料通知？',
    a: '推荐下载每日大瓜 APP 开启推送通知，或关注我们的社交媒体账号。重大爆料通常会在事件发生后 2 小时内发布首篇速报。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">吃瓜问答</h2>
          <p className="mt-2 text-sm text-foreground-500">常见问题一次解答</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.q}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0">Q.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}